import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Utensils, RefreshCw } from 'lucide-react';
import { FoodSearch } from '../../components/nutrition/FoodSearch';
import { useFoodSwaps } from '../../features/vacation/hooks/useFoodSwaps'; // Fixed import path

export function FoodSwapSection() {
  const { currentSwap, refreshSwap, searchFoods, handleFoodSelect } = useFoodSwaps();
  const [searchQuery, setSearchQuery] = useState('');

  if (!currentSwap) return null;

  const caloriesSaved = currentSwap.from.calories - currentSwap.to.calories;

  return (
    <div className="bg-muted/10 backdrop-blur-xl rounded-xl p-4 space-y-4 border border-muted/20">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="relative">
            <Utensils className="w-6 h-6 text-primary/80" />
            <div className="absolute inset-0 bg-primary/10 blur-xl rounded-full animate-pulse" />
          </div>
          <h3 className="font-medium">Smart Food Swap</h3>
        </div>
        <button
          onClick={refreshSwap}
          className="p-2 rounded-lg hover:bg-muted/20 transition-all"
          aria-label="Show next food swap"
        >
          <RefreshCw className="w-5 h-5 text-primary/80" />
        </button>
      </div>

      <FoodSearch
        value={searchQuery}
        onChange={setSearchQuery}
        onSelect={handleFoodSelect}
        filteredFoods={searchFoods(searchQuery)}
      />

      <motion.div
        key={currentSwap.from.name}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="bg-background/40 backdrop-blur-sm rounded-lg p-4 border border-muted/10"
      >
        <div className="grid grid-cols-2 gap-6">
          {/* From Food */}
          <div className="text-center">
            <div className="text-4xl mb-2 filter drop-shadow-lg">{currentSwap.from.emoji}</div>
            <div className="text-sm text-destructive/70 font-medium">Instead of</div>
            <div className="text-sm mt-1 text-foreground/80">{currentSwap.from.name}</div>
            <div className="text-xs text-muted-foreground/80 mt-1">
              {currentSwap.from.calories} calories
            </div>
          </div>

          {/* To Food */}
          <div className="text-center">
            <div className="text-4xl mb-2 filter drop-shadow-lg">{currentSwap.to.emoji}</div>
            <div className="text-sm text-success/70 font-medium">Try</div>
            <div className="text-sm mt-1 text-foreground/80">{currentSwap.to.name}</div>
            <div className="text-xs text-muted-foreground/80 mt-1">
              {currentSwap.to.calories} calories
            </div>
          </div>
        </div>

        <div className="mt-4 text-center text-primary/80 font-medium border-t border-muted/10 pt-4 backdrop-blur-sm">
          Save {caloriesSaved} calories with this swap! 💪
        </div>
      </motion.div>
    </div>
  );
}